import React, { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { Link, useNavigate } from "react-router-dom";
import {
  getAllAdminUser,
  activateDeactivateAdmin,
  deactivateUser,
} from "../../apis";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import actions from "../../actions";
import Pagination from "../../components/Pagination/Pagination";
import AddEdit from "./AddEdit";
import ChangePassword from "./ChangePassword";

const Admins = ({ logoutRequest, startLoadingRequest, stopLoadingRequest }) => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [totalUser, setTotalUser] = useState(null);
  const { pathname, search } = useLocation();
  const [searchTerm,setSearchTerm] = useState('')
  const rowsPerPage = 10;
  const navigate = useNavigate();
  const [userDetails,setUserDetails]=useState(JSON.parse(localStorage.getItem('userDetails')));
  const fetch = useCallback(async (pageNum = page, searchValue = searchTerm) => {
    try {
      startLoadingRequest();
      const apiResponse = await getAllAdminUser(pageNum, rowsPerPage, searchValue);
 
      if (apiResponse) {
        setData(apiResponse.data?.data?.data);

        setTotalUser(apiResponse.data.data.totalUsers);
        setCurrentPage(apiResponse.data.data.currentPage);
        setPage(apiResponse?.data?.data?.currentPage);
      } else {
        setData([]);
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        toast.error(error.response.data.message);
        logoutRequest();
      } else if (error?.response?.status === 403) {
        toast.error(error.response.data.message);
      }
    } finally {
      stopLoadingRequest();
    }
  }, [rowsPerPage, startLoadingRequest, stopLoadingRequest, logoutRequest]);

  useEffect(() => {
    const searchParams = new URLSearchParams(search);
    const pageFromUrl = Number(searchParams.get('page')) || 1;
    setPage(pageFromUrl);
    fetch(pageFromUrl, searchTerm);
  }, [search]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (searchTerm !== undefined) {
        fetch(1, searchTerm);
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [searchTerm, fetch]);

  const handlePageChange = useCallback((newPage) => {
    const pageNum = Number(newPage);
    navigate(`/admins?page=${pageNum}`);
    setPage(pageNum);
    fetch(pageNum, searchTerm);
  }, [navigate, fetch, searchTerm]);

  const searchChangeHandler = useCallback((event) => {
    setSearchTerm(event.target.value);
  }, []);

  const activateDeactivateAdminHandler = useCallback(
    async (id, requestType) => {
      try {
        startLoadingRequest();
        await deactivateUser({ userId: id }, { requestType });
        fetch(page, searchTerm);
        toast.success(
          requestType === 1
            ? "Admin activated successfully"
            : "Admin deactivated successfully"
        );
      } catch (error) {
        if (error?.response?.status === 401) {
          toast.error(error.response.data.message);
          logoutRequest();
        } else if (error?.response?.status === 403) {
          toast.error(error.response.data.message);
        }
        stopLoadingRequest();
      }
    },
    [fetch, page, searchTerm, startLoadingRequest, stopLoadingRequest, logoutRequest]
  );

  return (
    <div className="section">
      <h1>Admins</h1>
      <div className="wrapper">
        <div className="table-wrapper">
          <div className="table-header">
          <div className="search">
              <div className="input-wrapper">
                <input
                  value={searchTerm}
                  onChange={searchChangeHandler}
                  placeholder="Search..."
                />
                {/* {searchTerm?.trim() && (
                  <RxCrossCircled onClick={resetSearchHandler} size={18} />
                )} */}
              </div>
            </div>
            <AddEdit fetch={fetch} />
          </div>
         
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Gender</th>
                  <th>Status</th>
                  <th>Role</th>
                  <th>Last Updated At</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {data?.length > 0 ? (
                  data?.map((item, index) => (
                    <tr key={item._id}>
                      <td>{index + 1}</td>
                      <td>{item.firstName}</td>
                      <td>{item.lastName}</td>
                      <td>{item.email}</td>
                      <td>{item.gender}</td>
                      <td>{item.isActive ? "Active" : "Inactive"}</td>
                      <td>{item?.roleId?.name || "No Role Assigned"}</td>
                      <td>
                        {item.updatedAt
                          ? new Date(item.updatedAt).toLocaleString()
                          : "N/A"}
                      </td>
                      <td>
                        <div className="table-actions">
                          {item?.isActive ? (
                            <>
                              <AddEdit data={item} fetch={fetch} userDetails={userDetails}/>
                              {/* <ChangePassword data={item} fetch={fetch} /> */}
                              <button
                                className={`danger `}
                                onClick={() =>
                                  
                                  activateDeactivateAdminHandler(item._id, 0)
                                }
                                disabled={item?._id===userDetails?._id}
                              >
                                Delete
                              </button>
                            </>
                          ) : (
                            <button
                              onClick={() =>
                                activateDeactivateAdminHandler(item._id, 1)
                              }
                              className="success"
                            >
                              Activate
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" align="center">
                      No admins found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {data?.length > 0 && (
            <Pagination
              pageInfo={{
                page: currentPage,
                total: total,
                totaluser: totalUser,
                rowsPerPage: rowsPerPage,
              }}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      logoutRequest: actions.auth.logout,
      stopLoadingRequest: actions.loader.stopLoading,
      startLoadingRequest: actions.loader.startLoading,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(Admins);
